module.exports = __webpack_public_path__ + "img/1sb_five_stars_unselected_reseller_d.11632d0.svg";